import axios from "./index";

/**
 * 获取充值记录列表
 */
export const getChargeRecord = (offset, limit = 10) => {
  return axios
    .get("/paymentOrders/paymentOrders", {
      params: {
        offset,
        limit
      }
    })
    .then(res => {
      return res;
    });
};

/**
 * 提交发票具体信息
 */
export const postInvoiceInfo = data => {
  const formData = new FormData();
  Object.keys(data).forEach(function(key) {
    formData.append(key, data[key]);
  });
  return axios({
    method: "POST",
    url: "/invoice/invoice",
    data: formData
  });
};
